export enum QueryableTableSupport {
    // Don't support queryable tables
    Disable = "disable",
    // Load more data as the user pages through
    LoadOnDemand = "load-on-demand",
    // Load all data as quickly as possible
    LoadAll = "load-all",
}
